<template>
  <div
    id="icons-results"
    class="icon-listing compact"
  >
    <icon
      v-for="icon in icons"
      :key="icon.objectID"
      :icon="icon"
      :icon-style="icon.style"
      :selected-icon-id="selectedIconId"
      :selected-family="selectedFamily"
      :selected-style="selectedStyle"
      :is-pro-user="isProUser"
      :results-view="resultsView"
      :version="version"
      button-hover-color="var(--theme-action-primary)"
      @toggleIcon="toggleIcon"
    />

    <site-link
      :to="viewAllLink"
      class="button icon flat with-border margin-bottom-0 display-flex flex-column flex-items-center flex-content-center"
      style="width: 100%; gap: var(--spacing-xs); --border-color: var(--fa-gravy); --button-background: transparent; --button-color: var(--fa-navy)"
      @click.native="$posthog.capture('pack_landing:all_family_style_link_click', { family: selectedFamily, style: selectedStyle })"
    >
      <font-awesome-icon
        :icon="$v6.solid.faGrid2"
        fixed-width
        size="lg"
      />

      View All
      <span class="sr-only">{{ selectedFamily }} {{ selectedStyle }} Icons</span>
    </site-link>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectHits } from 'instantsearch.js/es/connectors'
  import Icon from 'app/views/icons/components/icons/Icon'

  export default {
    name: 'IconList',

    components: {
      Icon
    },

    mixins: [createWidgetMixin({ connector: connectHits })],

    inject: ['iconPack'],

    props: {
      isProUser: {
        type: Boolean
      },
      resultsView: {
        type: String
      },
      searchFieldFocus: {
        type: Boolean,
        required: true
      },
      selectedFamily: {
        type: String
      },
      selectedIconId: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      version: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        iconObjectId: null
      }
    },

    computed: {
      icons() {
        return this.state ? this.state.hits : null
      },

      query() {
        return this.state.query
      },

      viewAllLink() {
        return this.selectedStyle === 'brands'
          ? this.$search({ iconCollections: ['brands'] })
          : this.$search({ family: this.selectedFamily, styles: this.selectedStyle })
      }
    },

    methods: {
      closeIcon() {
        this.$emit('closeIcon')
      },

      getCurrentIconIndex() {
        return this.state.hits.findIndex((i) => i.objectID == this.iconObjectId)
      },

      navigate(direction) {
        if (!this.state) return

        const currentIndex = this.getCurrentIconIndex()
        const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1
        const icon = this.state.hits[nextIndex]

        if (icon && nextIndex >= 0 && nextIndex < this.state.hits.length) {
          this.toggleIcon(icon, `icon-${icon.family}-${icon.name}-${icon.style}`, icon.objectID)
        }
      },

      next() {
        this.navigate('next')
      },

      previous() {
        this.navigate('previous')
      },

      scrollToIcon(iconElement) {
        const element = document.querySelector(`#${iconElement}`)
        element.scrollIntoView()
      },

      toggleIcon(icon, elementTag, objectId) {
        if (icon.family === this.selectedFamily && icon.style === this.selectedStyle) {
          this.state.sendEvent('click', icon, 'Icon Clicked')
          this.iconObjectId = objectId
          this.$emit('toggleIcon', icon, elementTag)
        }
      }
    }
  }
</script>
